<div class="tw-px-0 tw-py-[1.5rem] md:tw-p-[2.5rem] tw-w-full">
    <div class="tw-flex tw-flex-col tw-gap-[3rem] tw-w-full md:tw-w-[27.5rem] tw-mx-auto">
        <div class="tw-flex tw-flex-col tw-gap-[1rem]">
            <div class="title tw-text-[1.5rem] tw-leading-[2rem] md:tw-text-[2rem] md:tw-leading-[2.5rem]">
                {{'JoinGroupDialog.JoinSubgroupProceedTitle' | translate}}</div>
            <div class="sub-title tw-text-[1rem] md:tw-text-[1.125rem] tw-leading-[1.5rem] md:tw-leading-[1.625rem]">
                {{'JoinGroupDialog.JoinSubgroupProceedSubTitle' | translate}}
                <span class="bold"> {{'Profile' | translate}}>{{'ProfilePage.Membership' | translate}}</span>
            </div>
        </div>

        <div class="tw-flex tw-justify-center tw-items-center">
            <img src="assets/images/groups/subgroup-proceed.svg" class="tw-w-[14.375rem] md:tw-w-[22.5rem]" />
        </div>

        <button (click)="onClick()" class="action-btn gradient-btn join-btn" mat-flat-button color="primary">
            <span [translate]="'JoinGroupDialog.JoinSubgroupProceedBtn'"></span>
        </button>
    </div>
</div>